import { AlertModel } from "stores/plc/utils/alerts/utils";
import { CropRecipe } from "types/CropRecipe";
import { Cycle } from "types/Cycle";
import { Farm } from "types/Farm";
import { Recipe } from "types/Recipe";
import { Component } from "types/Service";


export function farmToCopilot(farm: Farm) {
	if (!farm) return null;
	return {
		id: farm.id,
		name: farm.name,
		country: farm.country,
		components: farm.edgeServicesConfig?.components?.map(c => componentToCopilot(c)) ?? []
	};
}

export function componentToCopilot(component: Component) {
	if (!component) return null;
	return {
		code: component.code,
		name: component.name,
		type: component.type,
	};
}

export function cropToCopilot(crop: CropRecipe) {
	if (!crop) return null;
	return {
		id: crop.id,
		uuid: crop.uuid,
		name: crop.name,
		farmIds: crop.farmIds,
		variety: crop.variety,
		expectedYieldPerMq: crop.expectedYieldPerMq,
		cost1kg: crop.cost1kg,
		seedCostPerMillion: crop.seedCostPerMillion,
	};
}

export function recipeToCopilot(recipe: Recipe) {
	if (!recipe) return null;
	return {
		id: recipe.id,
		uuid: recipe.uuid,
		name: recipe.name,
		farmIds: recipe.farmIds,
		totaldays: recipe.totalDays,
	};
}

export function plcAlertToCopilot(alert: AlertModel) {
	if (!alert) return null;
	return {
		code: alert.code,
		description: alert.description,
		component_code: alert.component?.code,
		isAck: alert.isAck,
	}
}

export function cycleToCopilot(cycle: Cycle) {
	if (!cycle) return null;
	return {
		id: cycle.id,
		uuid: cycle.cycleUuid,
		cropLots: cycle.cropLots,
		growUnitId: cycle.growUnitId,

		layers: cycle.layers,

		seedingDate: cycle.seedingDate,
		harvestingDate: cycle.harvestingDate,
		rejectingDate: cycle.rejectingDate,
		yieldDate: cycle.yieldDate,

		plannedYield: cycle.harvestingDate,
		yield: cycle.yield,
		lostYield: cycle.harvestingDate,
		numberOfAttachments: cycle.harvestingDate,
		numberOfIncidents: cycle.harvestingDate,
	};
}